const projects = [
    {
      key: 1,
      title: "Product 1 draft",
      content: "Eat more sushi"
    },
     {
      key: 2,
      title: "Product 2 draft",
      content: "Eat more sushi"
    }
    ,
    {
      key: 3,
      title: "Product 3 draft",
      content: "Eat more sushi"
    },
    {
      key: 4,
      title: "Product 4 draft",
      content: "Eat more sushi"
    }
    ,
    {
      key: 5,
      title: "Product 5 draft",
      content: "Eat more sushi"
    },
    {
      key: 6,
      title: "Product 6 draft",
      content: "Eat more sushi"
    },
    {
      key: 7,
      title: "Product 6 draft",
      content: "Eat more sushi"
    },
    {
      key: 8,
      title: "Product 6 draft",
      content: "Eat more sushi"
    },
    {
      key: 9,
      title: "Product 6 draft",
      content: "Eat more sushi"
    },
    {
      key: 10,
      title: "Product 6 draft",
      content: "Eat more sushi"
    }
    
    
  ];
  
  export default projects;
  